import gsap from 'gsap';
const closeToggled = (id) => {
  if (id) {
    [...document.querySelectorAll(`[data-toggle='${id}']:not([data-toggle-persistent]).active`)].map(item => {
      item.classList.remove('active');

      if (item.hasAttribute('aria-expanded')) {
        item.setAttribute('aria-expanded', 'false');
      }

    });

    [...document.querySelectorAll(`[data-toggle-element='${id}']:not([data-toggle-persistent]).toggled`)].map(item => {
      item.classList.remove('toggled');
    });


  } else {
    [...document.querySelectorAll(`[data-toggle]:not([data-toggle-persistent]).active`)].map(item => {
      item.classList.remove('active');

      if (item.hasAttribute('aria-expanded')) {
        item.setAttribute('aria-expanded', 'false');
      }

    });

    [...document.querySelectorAll(`[data-toggle-element]:not([data-toggle-persistent]).toggled`)].map(item => {
      item.classList.remove('toggled');
    });

  }

  if (document.querySelector(`[data-toggle]:not([data-toggle-persistent]).active`)) return false;
  
  document.querySelector('.header--banner')?.removeAttribute('style');
};
export default function toggleFn() {
  const buttons = document.querySelectorAll('[data-toggle]');

  for (const button of buttons) {
    button.addEventListener('click', () => {
      const id = button.dataset.toggle;
      const elementsToToggle = document.querySelectorAll(`[data-toggle-element=${id}]`);

      const is_unique = button.dataset.toggleUnique;

      if (is_unique && !button.classList.contains('active')) {
        const unique_buttons = document.querySelectorAll(`[data-toggle-unique="${is_unique}"]`);
        const unique_containers = document.querySelectorAll(`[data-toggle-element-unique="${is_unique}"]`);

        [...unique_buttons].map(button => button.classList.remove('active'));
        [...unique_containers].map(container => container.classList.remove('toggled'));
      }

      [...document.querySelectorAll(`[data-toggle=${id}]`)].map(item => item.classList.toggle('active'));

      [...elementsToToggle].map(item => {
        const close_button = item.querySelector('.button--close');
        const last_link = item.querySelectorAll('a, button, input')[item.querySelectorAll('a, button, input').length - 1];
        const first_link = item.querySelector('a, button, input');
        item.classList.toggle('toggled');

        if (window.is_mobile) {
          const hidden = !item.classList.contains('toggled');
          //item.setAttribute('aria-hidden', hidden);
        }

        /*
        if (!window.is_mobile) {
          if (id === 'search') {
            item.querySelector('input').focus();
          }
          else {
            first_link?.focus();
          }
        }
        * */

        if (!button.classList.contains('active')) {
          closeToggled(id);
        } else {
          const headerBanner = document.querySelector('.header--banner');

          if (headerBanner) {
            if (headerBanner.getBoundingClientRect().top >= 0) {
              if (['search', 'menu'].includes(id)) {
                gsap.set('.header--banner', {
                  display: 'none'
                })
              }
            }
          }
        }

        item.addEventListener('keydown', function(e) {
          const isTabPressed = (e.key === 'Tab' || e.keyCode === 9);
          if (!isTabPressed) { return; }

          if (e.shiftKey) { // Shift + Tab
            if (document.activeElement === close_button || document.activeElement === button) {
              last_link.focus();
              e.preventDefault();
            }
          }
          else { // Tab
            if (document.activeElement === last_link) {
              if (close_button) {
                close_button.focus();
              } else {
                button.focus()
              }

              e.preventDefault();
            }
          }
        });

        /*
                //ACCESSIBILITY
                last_link?.addEventListener('blur', () => {
                  if (!close_button) {
                    button.classList.remove('active');
                    item.classList.remove('toggled');
                  } else {
                    first_link.focus();
                  }
                });*/
      });

      if (button.hasAttribute('aria-expanded')) {
        button.setAttribute('aria-expanded', button.classList.contains('active'));
      }
    });
  }

  window.addEventListener('click', e => {
    if (!e.target.closest('[data-toggle]') && !e.target.closest('[data-toggle-element]')) {
      closeToggled();
    }
  });

  window.addEventListener('keyup', e => {
    if (e.key === 'Escape') {
      closeToggled();
    }
  })
};
